import React, { useState } from 'react';
import Layout from '../components/Layout/Layout.js';
import { useSearch } from '../context/search.js';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/cart.js';
import toast from 'react-hot-toast';
import QuickView from '../components/QuickView.js';

const Search = () => {
    const [values] = useSearch();
    const navigate = useNavigate();
    const [cart, setCart] = useCart();
    const [quickViewProduct, setQuickViewProduct] = useState(null);

  return (
    <Layout title={'نتائج البحث'}>
      {/* Hero */}
      <div className="categories-hero">
        <img src="/images/logo2.jpeg" alt="النخبة ستور" className="categories-hero-bg" />
        <div className="categories-hero-overlay">
          <h1>نتائج البحث</h1>
          <p>
            {values?.results.length < 1
              ? "لم يتم العثور على منتجات"
              : `تم العثور على ${values?.results.length} نتيجة`}
          </p>
        </div>
      </div>

      <div className='container' style={{paddingTop: '40px', paddingBottom: '60px'}}>
        <div className='d-flex flex-wrap justify-content-center'>
          {values?.results.map((p, index) => (
            <div className="card product-card m-2" key={p._id} style={{animationDelay: `${index * 0.08}s`}}>
              <div className="card-img-wrapper">
                <button className="qv-trigger" type="button" aria-label="عرض سريع" onClick={() => setQuickViewProduct(p)} title="عرض سريع">👁</button>
                <img src={`/api/v1/products/product-photo/${p._id}`} className="card-img-top" alt={p.name} loading="lazy" onClick={() => setQuickViewProduct(p)} style={{cursor:'pointer'}} />
              </div>
              <div className="card-body">
                <h5 className="card-title">{p.name}</h5>
                <h5 className="card-title card-price">
                  {p.price.toLocaleString("ar-IQ")} د.ع
                </h5>
              </div>
              <p className="card-text">
                {p.description.substring(0, 60)}...
              </p>
              <div className="card-name-price">
                <button className="btn btn-glass ms-1" onClick={() => setQuickViewProduct(p)}>التفاصيل</button>
                <button className="btn btn-gold-shimmer ms-1" onClick={() => {
                  setCart([...cart, p]);
                  localStorage.setItem("cart", JSON.stringify([...cart, p]));
                  toast.success("تمت الإضافة إلى السلة");
                }}>أضف إلى السلة</button>
              </div>
            </div>
          ))}
        </div>

        {values?.results.length < 1 && (
          <div className="empty-state">
            <div className="empty-state-icon">🔍</div>
            <h4>لم يتم العثور على نتائج</h4>
            <p>حاول البحث بكلمات مختلفة</p>
          </div>
        )}
      </div>
      {quickViewProduct && (
        <QuickView product={quickViewProduct} onClose={() => setQuickViewProduct(null)} />
      )}
    </Layout>
  );
};

export default Search;
